<dx-data-grid biz-grid [dataSource]="logs" [showBorders]="true" [bizSetColumnChooser]="false"
  [bizSetAllowColumnReordering]="false" [bizSetSearchPanel]="false" [bizHideSelectedRowsComponent]="true"
  [showResetButton]="false" [bizSetGroupPanel]="false" [bizSetPager]="false">

  <dxi-column dataField="LogLevel" caption="Status" cellTemplate="status" width="8em" alignment="center"
  [allowSorting]="false" [allowFiltering]="false"></dxi-column>
  <dxi-column dataField="LogText" caption="LogContent" dataType="string" width="100%" [allowFiltering]="false"
  [allowSorting]="false" [customizeText]="customizeText" [encodeHtml]="false"></dxi-column>

  <ng-container *dxTemplate="let row of 'status'">
    <div title="{{row.data.LogLevel}}">
      @if (row.data.LogLevel === 'Error') {
        <svg class="icon icon-times-circle-o error" viewBox="0 0 24 28">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/css/svg/icons.svg#times-circle-o"></use>
        </svg>
      }
      @if (row.data.LogLevel === 'Warning') {
        <svg class="icon icon-dot-circle-o warning" viewBox="0 0 24 28">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/css/svg/icons.svg#dot-circle-o"></use>
        </svg>
      }
      @if (row.data.LogLevel === 'Info') {
        <svg class="icon icon-check-circle-o info" viewBox="0 0 24 28">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/css/svg/icons.svg#check-circle-o"></use>
        </svg>
      }
      @if (row.data.LogLevel === 'Debug') {
        <svg class="icon icon-check-circle-o debug" viewBox="0 0 24 28">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/css/svg/icons.svg#check-circle-o"></use>
        </svg>
      }
    </div>
  </ng-container>
</dx-data-grid>
